<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';

import { TooltipProvider } from '@/components/ui/tooltip';
import AppToaster from '@components/atoms/AppToaster.vue';
import AuthTemplate from '@components/templates/AuthTemplate.vue';
import DefaultTemplate from '@components/templates/DefaultTemplate.vue';

const route = useRoute();

const isAuthRoute = computed(() => route.path === '/login');
</script>

<template>
  <TooltipProvider :delay-duration="200" :skip-delay-duration="300">
    <component :is="isAuthRoute ? AuthTemplate : DefaultTemplate">
      <RouterView v-slot="{ Component }">
        <Transition name="fade" mode="out-in">
          <component :is="Component" />
        </Transition>
      </RouterView>
    </component>
    <AppToaster />
  </TooltipProvider>
</template>
